export { Group }        from './group';
export { Organisation } from './organisation';
export { User }         from './user';



// WEBPACK FOOTER //
// ./src/app/models/index.ts